import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const ModuleDetailSkeleton: FC = () => (
  <Box sx={{ minHeight: 'calc(100vh - 140px)' }}>
    {/* Breadcrumb */}
    <Box display="flex" gap={1} mb={2} alignItems="center">
      <Skeleton variant="text" width={120} height={20} />
      <Skeleton variant="text" width={8} height={20} />
      <Skeleton variant="text" width={160} height={20} />
    </Box>

    {/* Progress bar */}
    <Box display="flex" alignItems="center" gap={2} mb={3} sx={{ maxWidth: { xs: '100%', md: 'calc(100% - 205px)' } }}>
      <Skeleton variant="text" width={36} height={24} sx={{ flexShrink: 0 }} />
      <Skeleton variant="rectangular" height={10} sx={{ flex: 1, borderRadius: 3 }} />
    </Box>

    {/* Description */}
    <Box mb={3} sx={{ maxWidth: { xs: '100%', md: 'calc(100% - 315px)' } }}>
      <Skeleton variant="text" width="100%" height={18} />
      <Skeleton variant="text" width="95%" height={18} />
      <Skeleton variant="text" width="80%" height={18} />
    </Box>

    {/* Section cards */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '14px', md: '17px' },
        maxWidth: { xs: '100%', md: 'calc(100% - 205px)' },
      }}
    >
      {Array.from({ length: 4 }).map((_, i) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Skeleton key={i} variant="rectangular" height={72} sx={{ borderRadius: 2 }} />
      ))}
    </Box>
  </Box>
);
